"use client"

import { format } from "date-fns"
import { ptBR } from "date-fns/locale"

import { IStatusHistory } from "@/@types/store-conciliation"
import { Badge } from "@/components/ui/badge"
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table"

interface StatusHistoryContentProps {
    statusHistory: IStatusHistory[]
}

export function StatusHistoryContent({ statusHistory }: StatusHistoryContentProps) {
    const sortedHistory = [...statusHistory].sort(
        (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
    )

    return (
        <div className="overflow-auto">
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>Status</TableHead>
                        <TableHead>Alterado por</TableHead>
                        <TableHead>Data</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {sortedHistory.map((item) => (
                        <TableRow key={item.id}>
                            <TableCell>
                                <Badge variant={item.status === "OPENED" ? "success" : "destructive"} className="font-medium">
                                    {item.status === "OPENED" ? "Aberto" : "Fechado"}
                                </Badge>
                            </TableCell>
                            <TableCell>{item.changed_by}</TableCell>
                            <TableCell>{format(new Date(item.created_at), "dd/MM/yyyy HH:mm", { locale: ptBR })}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </div>
    )
}
